module.exports = __webpack_public_path__ + "media/images/emblems/Morcote-coat_of_arms-dce3d993c4870dd541e6b0d007609276.svg";